import { rootApi } from '../../user/api';

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['ReceiveJob', 'ConfirmTrailerDriver', 'ReasonMasters'],
});

export const confirmDriverTrailerApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findAllConfirmTrailers: builder.query({
      query: (payload) => {
        let url = `confirm_trailer_driver/trailers/`;
        const params = [];
        // loop over payload entries, and expand any arrays into params array
        Object.entries(payload).forEach(([key, value]) => {
          if (value != null) {
            if (Array.isArray(value)) {
              params.push(...value.map((v) => [key, v]));
            } else {
              params.push([key, value]);
            }
          }
        });
        // construct query params using URLSearchParams
        const searchParams = new URLSearchParams(params);
        return { url: `${url}?${searchParams.toString()}` };
      },
      keepUnusedDataFor: 0,
      providesTags: ['ConfirmTrailerDriver'],
    }),

    findAllTrailersBySelection: builder.query({
      query: (payload) => {
        let url = `confirm_trailer_driver/selection_data/trailers/`;
        const params = [];
        // loop over payload entries, and expand any arrays into params array
        Object.entries(payload).forEach(([key, value]) => {
          if (value != null) {
            if (Array.isArray(value)) {
              params.push(...value.map((v) => [key, v]));
            } else {
              params.push([key, value]);
            }
          }
        });
        // construct query params using URLSearchParams
        const searchParams = new URLSearchParams(params);
        return { url: `${url}?${searchParams.toString()}` };
      },
      keepUnusedDataFor: 0,
      providesTags: ['ConfirmTrailerDriver'],
    }),

    findAllConfirmDrivers: builder.query({
      query: (payload) => {
        let url = `confirm_trailer_driver/drivers/`;
        const params = [];
        // loop over payload entries, and expand any arrays into params array
        Object.entries(payload).forEach(([key, value]) => {
          if (value != null) {
            if (Array.isArray(value)) {
              params.push(...value.map((v) => [key, v]));
            } else {
              params.push([key, value]);
            }
          }
        });
        // construct query params using URLSearchParams
        const searchParams = new URLSearchParams(params);
        return { url: `${url}?${searchParams.toString()}` };
      },
      keepUnusedDataFor: 0,
      providesTags: ['ConfirmTrailerDriver'],
    }),

    findAllConfirm: builder.query({
      query: (payload) => {
        let url = `confirm_trailer_driver/confirm/`;
        const params = [];
        // loop over payload entries, and expand any arrays into params array
        Object.entries(payload).forEach(([key, value]) => {
          if (value != null) {
            if (Array.isArray(value)) {
              params.push(...value.map((v) => [key, v]));
            } else {
              params.push([key, value]);
            }
          }
        });
        // construct query params using URLSearchParams
        const searchParams = new URLSearchParams(params);
        return { url: `${url}?${searchParams.toString()}` };
      },
      keepUnusedDataFor: 0,
      providesTags: ['ConfirmTrailerDriver'],
    }),

    findAllDriversBySelection: builder.query({
      query: (payload) => {
        let url = `confirm_trailer_driver/selection_data/drivers/`;
        const params = [];
        // loop over payload entries, and expand any arrays into params array
        Object.entries(payload).forEach(([key, value]) => {
          if (value != null) {
            if (Array.isArray(value)) {
              params.push(...value.map((v) => [key, v]));
            } else {
              params.push([key, value]);
            }
          }
        });
        // construct query params using URLSearchParams
        const searchParams = new URLSearchParams(params);
        return { url: `${url}?${searchParams.toString()}` };
      },
      keepUnusedDataFor: 0,
      providesTags: ['ConfirmTrailerDriver'],
    }),

    findConfirmTrailerDriverById: builder.query({
      query: (payload) =>
        `confirm_trailer_driver/trips/?job_code=${payload.job_code}&working_day=${payload.working_day}`,
      keepUnusedDataFor: 0,
    }),
    findConfirmTrailerDriverByCallingNo: builder.query({
      query: (callingsheet_no) =>
        `confirm_trailer_driver/calling_detail/?callingsheet_no=${callingsheet_no}`,
      providesTags: ['ConfirmTrailerDriver'],
    }),

    findAllDispatchBoardsReceiveJobByPagination: builder.query({
      query: (payload) => {
        let url = `dispatch_boards/receive_job/`;
        const params = [];
        // loop over payload entries, and expand any arrays into params array
        Object.entries(payload).forEach(([key, value]) => {
          if (value != null) {
            if (Array.isArray(value)) {
              params.push(...value.map((v) => [key, v]));
            } else {
              params.push([key, value]);
            }
          }
        });
        // construct query params using URLSearchParams
        const searchParams = new URLSearchParams(params);
        return { url: `${url}?${searchParams.toString()}` };
      },
      keepUnusedDataFor: 0,
      providesTags: ['ReceiveJob'],
    }),

    findCurrentTimeConfirmDriverTrailer: builder.query({
      query: () => `server_time/`,
      keepUnusedDataFor: 0,
      providesTags: ['ReceiveJob'],
    }),

    findConfirmTrailerDriverReasonMasterByModule: builder.query({
      query: (module) => `reasons/?module__name=${module}`,
      providesTags: (result, error, arg) => {
        return result
          ? [{ type: 'ReasonMasters', module: result.module }]
          : ['ReasonMasters'];
      },
    }),

    findConfirmTrailerDriverGroupReasonByCode: builder.query({
      query: (code) => `reasons/?&subject_reason__group__code=${code}`,
      providesTags: (result, error, arg) => {
        return result
          ? [{ type: 'ReasonMasters', id: result.id }]
          : ['ReasonMasters'];
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindAllConfirmTrailersQuery,
  useFindConfirmTrailerDriverByIdQuery,
  useFindConfirmTrailerDriverByCallingNoQuery,
  useFindAllDispatchBoardsReceiveJobByPaginationQuery,
  useFindCurrentTimeConfirmDriverTrailerQuery,
  useFindConfirmTrailerDriverReasonMasterByModuleQuery,
} = confirmDriverTrailerApi;
